/* eslint-disable react-hooks/exhaustive-deps */
import "./CSS/DashboardScreen.css";
import leftWhiteIcon from "../../assets/images/dashboard-left-white.svg";
import leftOrengeIcon from "../../assets/images/dashboard-left-orenge.svg";
import rightWhiteIcon from "../../assets/images/dashboard-right-white.svg";
import rightOrengeIcon from "../../assets/images/dashboard-right-orenge.svg";
import infoIcon from "../../assets/images/dashboard-info-icon.svg";
import underReviewIcon from "../../assets/images/dashboard-under-review-icon.svg";
import headerAppIcon from "../../assets/images/header-sabehub-app-icon.svg";
import headerAppTextIcon from "../../assets/images/header-sabehub-text-app-icon.svg";
import headerConnectIcon from "../../assets/images/dashboard-quick-menu-icon.svg";
import headerRSVPLocationIcon from "../../assets/images/dashboard-rsvp-location-icon.svg";
import dashboardGreenStarIcon from "../../assets/images/dashboard-screen-green-star.svg";
import hotIconJoinExperience from "../../assets/images/dashboard-join-experience-hoticon.svg";
import hotIconBecomeMember from "../../assets/images/dashboard-become-member-hoticon.svg";
import hotIconBookSpace from "../../assets/images/dashboard-book-space-hoticon.svg";
import { useEffect, useRef, useState } from "react";
import DashboardScreenDetailFooter from "./Views/DashboardScreenDetailFooter";
import { useQuery } from "@tanstack/react-query";
import useWSMApi from "services/api/useWSMApi";
import BecomeMemberDialog from "components/elements/BecomeMemberDialog";
import ROUTE_PATHS from "utils/routePaths";
import { useNavigate } from "react-router-dom";
import {
  CALENDAR_RESERVATION_TYPE,
  LaunchDateCleanFuelCafe,
  LaunchDateCreativeSpace,
  LaunchDateHotlineHours,
  LaunchDateMBStudio,
  MEMBERSHIP_FOUNDER_TYPE,
  MENU_ITEM,
  PROFILE_STATUS,
} from "utils/constants";
import { useTabBar } from "services/TabBarProvider";
import { WEB_LINK } from "utils/strings";
import { useStorage } from "services/StorageProvider";
import ComingUpEventsView from "./Views/ComingUpEventsView";
import {
  trackHomeView,
  trackCategoryClick,
  trackItemClick,
} from "utils/analytics";
import cleanFuelCafeImage from "../../assets/images/member-benefits-clean-fuel-cafe.png";
import creativeImage from "../../assets/images/member-benefits-creative.png";
import mbStudioImage from "../../assets/images/member-benefits-mind-body-studio.png";
import cleanFuelImage from "../../assets/images/member-benefits-clean-fuel-cafe.png";
import FHHImage from "../../assets/images/member-benefits-founder-hotlinehours.png";
import cardFirstImage from "../../assets/images/dashboard-member-benefits-card-first.png";
import JoinCircleDialog from "components/elements/JoinCircleDialog";
import QuickMenuDialog from "components/elements/QuickMenuDialog";
import { getIsActiveMemberStatus } from "utils/utils";
import ChooseUrSpaceDialog from "components/elements/ChooseUrSpaceDialog";
import BecomeMemberPopup from "components/elements/BecomeMemberPopup";
interface Benefits {
  title: string;
  buttonTitle: string;
  image: string;
}

const DashboardScreen = () => {
  const today = new Date();
  const memberBenefits: Benefits[] = [
    {
      title: "Energy Space",
      buttonTitle:
        today < LaunchDateCleanFuelCafe
          ? "Available from 1st April"
          : "Explore",
      image: cleanFuelCafeImage,
    },
    {
      title: "Execution Space",
      buttonTitle:
        today < LaunchDateCreativeSpace
          ? "Available from 1st April"
          : "Explore",
      image: creativeImage,
    },
    {
      title: "Curated Experiences",
      buttonTitle: "Explore",
      image: cleanFuelImage,
    },
    {
      title: "Wellness",
      buttonTitle:
        today < LaunchDateMBStudio ? "Coming on 20th August" : "Explore",
      image: mbStudioImage,
    },
    {
      title: "The Foundry",
      buttonTitle:
        today < LaunchDateHotlineHours ? "Coming on 22nd April" : "Explore",
      image: FHHImage,
    },
  ];

  const navigate = useNavigate();
  const eventsContainerRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const [showBecomeMemberDialog, setShowBecomeMemberDialog] =
    useState<boolean>(false);
  const [showBecomeMemberPopup, setShowBecomeMemberPopup] =
    useState<boolean>(false);
  const [showQuickMenuDialog, setShowQuickMenuDialog] =
    useState<boolean>(false);
  const [showQBookSpaceDialog, setShowQBookSpaceDialog] =
    useState<boolean>(false);
  const [showJoinCircleDialog, setShowJoinCircleDialog] =
    useState<boolean>(false);
  const { setSelectedTabBar } = useTabBar();
  const { userProfileData, refreshUserProfile } = useStorage();
  const isActiveMember = getIsActiveMemberStatus(userProfileData);
  const { fetchComingUpEvents, fetchBulletinSlot, fetchReservations } =
    useWSMApi();

  const { data: bulletinSoltData } = useQuery({
    queryKey: ["fetch-bulletin-slot"],
    queryFn: () => fetchBulletinSlot(),
    retry: false,
  });

  const { data: comingUpEventsData } = useQuery({
    queryKey: ["fetch-coming-up-events"],
    queryFn: () => fetchComingUpEvents(),
    retry: false,
  });

  const { data: reservationsData, isError: reservationError } = useQuery({
    queryKey: ["fetch-user-reservations"],
    queryFn: () => fetchReservations(),
    retry: false,
  });

  useEffect(() => {
    refreshUserProfile();
    trackHomeView();
  }, []);

  const updateScrollButtons = () => {
    const el = eventsContainerRef.current;
    if (el) {
      setCanScrollLeft(el.scrollLeft > 0);
      setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    }
  };

  useEffect(() => {
    const storedLeadData = sessionStorage.getItem("customerLeadData");
    if (storedLeadData) {
      const leadData = JSON.parse(storedLeadData);
      if (leadData?.membership) {
        sessionStorage.setItem(
          "membershipSelectedTab",
          MEMBERSHIP_FOUNDER_TYPE.EXECUTION,
        );
        setSelectedTabBar(MENU_ITEM.MEMBERSHIP);
      }
      sessionStorage.removeItem("customerLeadData");
    }
  }, []);

  useEffect(() => {
    updateScrollButtons();
    const el = eventsContainerRef.current;
    if (!el) return;
    el.addEventListener("scroll", updateScrollButtons);
    window.addEventListener("resize", updateScrollButtons);
    return () => {
      el.removeEventListener("scroll", updateScrollButtons);
      window.removeEventListener("resize", updateScrollButtons);
    };
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    script.onload = () => {
      console.log("Razorpay script loaded");
    };
    document.body.appendChild(script);
  }, []);

  const scrollEvents = (direction: "left" | "right") => {
    if (eventsContainerRef.current && isActiveMember) {
      const scrollAmount = 200;
      eventsContainerRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
      setTimeout(updateScrollButtons, 300);
    }
  };

  const handleBulletinCardClick = (bulletinData: any) => {
    trackItemClick(bulletinData?.id, bulletinData?.title);
    const reservation = !reservationError
      ? reservationsData?.data?.content?.find(
          (reservation: any) =>
            reservation?.service_slot_id === bulletinData?.id,
        )
      : null;
    localStorage.setItem(
      "selectedReservationData",
      JSON.stringify(reservation),
    );
    localStorage.setItem("selectedSlotData", JSON.stringify(bulletinData));
    if (bulletinData.service_type === CALENDAR_RESERVATION_TYPE.RETREAT) {
      navigate(
        ROUTE_PATHS.WSM_RETREAT_DETAIL.replace(":slotId", bulletinData?.id),
      );
    } else {
      navigate(
        ROUTE_PATHS.WSM_WORKSPACE_DETAIL.replace(":slotId", bulletinData?.id),
      );
    }
  };

  const handleMemberBenefitsChange = (index: number) => {
    const categoryNames = [
      "Energy Space",
      "Create Space",
      "Innovate Space",
      "Communicate space",
      "Experiences",
      "Retreats",
      "Wellness",
      "Scaling Workshops",
      "The Foundry",
    ];
    if (categoryNames[index]) {
      trackCategoryClick(categoryNames[index]);
    }
    if (index === 0) {
      navigate(ROUTE_PATHS.WSM_WEB_LINK_DETAIL, {
        state: {
          anyData: {
            title: "Energy Space",
            url: WEB_LINK.ENERY_SPACE,
          },
        },
      });
    } else if (index === 1) {
      navigate(ROUTE_PATHS.WSM_CALENDAR_CREATIVE_SPACE);
    } else if (index === 2) {
      navigate(ROUTE_PATHS.WSM_CALENDAR_EVENT_DETAIL);
    } else if (index === 3) {
      navigate(ROUTE_PATHS.WSM_WEB_LINK_DETAIL, {
        state: {
          anyData: {
            title: "Wellness",
            url: WEB_LINK.WELNESS_LINK,
          },
        },
      });
    } else if (index === 4) {
      navigate(ROUTE_PATHS.WSM_WEB_LINK_DETAIL, {
        state: {
          anyData: {
            title: "The Foundry",
            url: WEB_LINK.THE_FOUNDRY_URL,
          },
        },
      });
    }
  };

  const getHeaderContent = () => {
    if (userProfileData?.credit?.status === PROFILE_STATUS.NON_MEMBER) {
      return (
        <button
          className="member-button"
          onClick={() => {
            navigate(ROUTE_PATHS.WSM_WEB_LINK_DETAIL, {
              state: {
                anyData: {
                  title: "Become A Member",
                  url: WEB_LINK.BECOME_MEMBER,
                },
              },
            });
          }}
        >
          Become a Member
        </button>
      );
    } else if (
      userProfileData?.credit?.status === PROFILE_STATUS.UNDER_REVIEW
    ) {
      return (
        <>
          <button
            className="member-button"
            onClick={() => setShowBecomeMemberDialog(true)}
          >
            Become a Member
            <img src={underReviewIcon} alt="under-review-icon" />
          </button>
          <div className="info-container">
            <img src={infoIcon} alt="info-icon" />
            <span>
              Membership Review is{" "}
              <span style={{ color: "#ff6b35" }}>Under Way.</span>
            </span>
          </div>
        </>
      );
    } else if (
      userProfileData?.credit?.status === PROFILE_STATUS.PAYMENT_PENDING
    ) {
      return (
        <>
          <button
            className="member-button"
            style={{ backgroundColor: "#C1F700" }}
            onClick={() => setSelectedTabBar(MENU_ITEM.MEMBERSHIP)}
          >
            You're in .. Almost
          </button>
          <div className="info-container" style={{ width: "242px" }}>
            <img src={infoIcon} alt="info-icon" />
            <span>
              Membership Approved,{" "}
              <span style={{ color: "#ff6b35" }}>Complete your payment</span>
            </span>
          </div>
        </>
      );
    }
  };

  const handleComingUpCardClick = (event: any) => {
    const reservation = !reservationError
      ? reservationsData?.data?.content?.find(
          (reservation: any) => reservation?.service_slot_id === event?.id,
        )
      : null;
    localStorage.setItem(
      "selectedReservationData",
      JSON.stringify(reservation),
    );
    localStorage.setItem("selectedSlotData", JSON.stringify(event));
    navigate(ROUTE_PATHS.WSM_WORKSPACE_DETAIL.replace(":slotId", event?.id));
  };

  const handleHotLinkClick = (index: number) => {
    if (index === 1) {
      setShowQBookSpaceDialog(true);
    } else if (index === 2) {
      sessionStorage.setItem(
        "calendarSelectedTab",
        CALENDAR_RESERVATION_TYPE.EVENTS,
      );
      setSelectedTabBar(MENU_ITEM.CALENDAR);
    } else {
      setShowBecomeMemberPopup(true);
    }
  };

  return (
    <div className="wms-mobile-container">
      <div className="dashboard-screen-main-container">
        <div className="dashboard-screen-header-bar">
          <div className="header-container">
            <img
              src={headerAppIcon}
              alt="header-app-icon"
              className="header-app-icon "
            />
            <img src={headerAppTextIcon} alt="header-text-app-icon" />
          </div>
          <div
            className="right-container"
            onClick={() => setShowQuickMenuDialog(true)}
          >
            <img src={headerConnectIcon} alt="left-button" />
            <span>Quick Menu</span>
          </div>
        </div>
        <div className="dashboard-screen-header-container">
          <div className="welcome-container">
            <div className="title">Hola!</div>
          </div>
          <div className="sub-title">{`${userProfileData?.first_name}`}</div>
          <div className="header-message-title">
            Everything you need for a stronger workday
          </div>
          {/* {isActiveMember ? (
            <div className="sub-title">{`${userProfileData?.first_name}`}</div>
          ) : (
            getHeaderContent()
          )} */}
        </div>
        <div className="dashboard-screen-hot-links-container">
          <div
            className="button-container"
            onClick={() => handleHotLinkClick(1)}
          >
            <div className="circular-container">
              <img src={hotIconBookSpace} alt="profile-coin-icon" />
            </div>
            Book a Space
          </div>
          <div
            className="button-container"
            onClick={() => handleHotLinkClick(2)}
          >
            <div className="circular-container">
              <img src={hotIconJoinExperience} alt="profile-coin-icon" />
            </div>
            Join an Experience
          </div>
          <div
            className="button-container"
            onClick={() => handleHotLinkClick(3)}
          >
            <div className="circular-container">
              <img src={hotIconBecomeMember} alt="profile-coin-icon" />
            </div>
            Become a Member
          </div>
        </div>
        {bulletinSoltData?.data?.content?.length > 0 && (
          <div className="dashboard-screen-detail-container">
            <div className="header-bar-container">
              <div className="left-conatiner">
                <span>Featured</span>
                <img src={dashboardGreenStarIcon} alt="left-button" />
              </div>
              {/* <div className="location-container">
                <img src={headerRSVPLocationIcon} alt="profile-coin-icon" />
                {bulletinSoltData?.slot_country}
              </div> */}
            </div>
            <div className="divider" />
            <div className="dashboard-screen-bulletin-container">
              {bulletinSoltData?.data?.content?.map(
                (event: any, index: number) => (
                  <div
                    className="dashboard-screen-detail-sub-container"
                    key={event?.id ?? index}
                  >
                    <div
                      className="left-container"
                      style={{
                        backgroundImage: `url(${event?.slot_image})`,
                      }}
                      onClick={() => handleBulletinCardClick(event)}
                    >
                      <div className="header-container">
                        <div className="header-bar">{event?.title}</div>
                        <div className="location-container">
                          <img
                            src={headerRSVPLocationIcon}
                            alt="profile-coin-icon"
                          />
                          {event?.slot_country}
                        </div>
                      </div>
                      <DashboardScreenDetailFooter
                        slotDate={event?.slot_date}
                        slotTime={event?.start_time}
                        onClickRSVP={() => handleBulletinCardClick(event)}
                      />
                    </div>
                  </div>
                ),
              )}
            </div>
          </div>
        )}

        {comingUpEventsData?.data?.content?.length > 0 && (
          <div className="dashboard-screen-coming-up-container">
            <div className="header-container">
              <span>
                coming <span style={{ color: "#FF6B35" }}>up</span>
              </span>
              <div className="button-container">
                <img
                  src={canScrollLeft ? leftOrengeIcon : leftWhiteIcon}
                  alt="left-button"
                  onClick={() => canScrollLeft && scrollEvents("left")}
                />
                <img
                  src={canScrollRight ? rightOrengeIcon : rightWhiteIcon}
                  alt="right-button"
                  onClick={() => canScrollRight && scrollEvents("right")}
                />
              </div>
            </div>
            <div className="divider"></div>
            <div className="dashboard-screen-coming-up-events-container-events-wrapper">
              <div
                className="dashboard-screen-coming-up-events-container"
                ref={eventsContainerRef}
              >
                {comingUpEventsData?.data?.content?.map(
                  (event: any, index: number) => (
                    <ComingUpEventsView
                      key={index}
                      event={event}
                      onClick={() => handleComingUpCardClick(event)}
                    />
                  ),
                )}
              </div>
            </div>
          </div>
        )}

        <div className="dashboard-screen-member-benefits-container">
          <span>
            workday <span style={{ color: "#FF6B35" }}>Ecosystem</span>
          </span>
          <div className="dashboard-screen-member-benefits-list-container">
            {memberBenefits.map((benefits, index) => (
              <div key={index}>
                <div className="divider"></div>
                <div
                  key={index}
                  className="dashboard-screen-member-benefits-list-item"
                  style={{
                    backgroundImage: `url(${benefits.image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                  onClick={() => handleMemberBenefitsChange(index)}
                >
                  <div
                    className={`dashboard-screen-member-benefits-list-sub-item ${
                      index % 2 === 0 ? "odd-card" : "even-card"
                    }`}
                  >
                    <div className="title">{benefits.title}</div>
                    <div className="btn-container">
                      <button>{benefits.buttonTitle}</button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div
          className="dashboard-screen-member-benefits-container"
          style={{ marginBottom: "80px" }}
        >
          <span>Connect</span>
          <div className="dashboard-screen-member-benefits-list-container">
            <div>
              <div className="divider"></div>
              <div
                className="dashboard-screen-member-benefits-list-item"
                style={{
                  backgroundImage: `url(${cardFirstImage})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <div
                  className={`dashboard-screen-contact-item-container`}
                  onClick={() => setShowJoinCircleDialog(true)}
                >
                  <div className="title">Join Our Private Circle</div>
                  <div className="sub-title">
                    Ask questions, find opportunities connect with the other
                    founders
                  </div>
                  {/* <div className="btn-container">
                    <button>Join the Channel on 8th April</button>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BecomeMemberDialog
        profileStatus={userProfileData?.credit?.status}
        open={showBecomeMemberDialog}
        onClose={() => setShowBecomeMemberDialog(false)}
      />
      <QuickMenuDialog
        userProfileData={userProfileData}
        isActiveMember={isActiveMember}
        open={showQuickMenuDialog}
        onClose={() => setShowQuickMenuDialog(false)}
      />
      <BecomeMemberPopup
        open={showBecomeMemberPopup}
        onClose={() => setShowBecomeMemberPopup(false)}
      />
      <ChooseUrSpaceDialog
        open={showQBookSpaceDialog}
        onClose={() => setShowQBookSpaceDialog(false)}
      />
      <JoinCircleDialog
        open={showJoinCircleDialog}
        onClose={() => setShowJoinCircleDialog(false)}
      />
    </div>
  );
};

export default DashboardScreen;
